var exports = {
  "k": "xf61da738--2b51a9--container",
};

module.exports = exports;
